import ToastMessage from '@/components/toasts/ToastMessage';
import api from '@/services/ApiService';
import useDataStore from '@/store/data';
import { useRouteLoaderData } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function useApiMutation(defaultSchema, defaultId) {
  const { upsert } = useDataStore();
  const { me } = useRouteLoaderData('auth');

  const mutationFn = async (data, schema, id) => {
    const { data: res } = id
      ? await api.put(`${schema}/${id}`, data)
      : await api.post(`${schema}`, data);
    return res;
  };

  const onSuccess = (result, variables, schema, id, notification) => {
    const obj = {
      _id: result?.insertedId || id,
      schema: `https://codemeta.de/schemas/${schema}`,
      createdAt: new Date(),
      ...variables,
    };
    if (result?.insertedId) {
      obj.createdBy = me._id;
    }

    upsert(obj);

    if (notification) {
      toast.success(
        <ToastMessage
          title="Erfolg"
          subtitle={
            id
              ? 'Daten wurden erfolgreich aktualisiert.'
              : 'Daten wurden erfolgreich hinzugefügt.'
          }
        />,
      );
    }

    return result;
  };

  const onError = (error, notification, throwError) => {
    if (notification || !throwError) {
      toast.error(
        <ToastMessage
          title="Fehler beim Speichern"
          subtitle={error?.message}
        />,
      );
    }
    if (throwError) {
      throw error;
    }
  };

  const mutateAsync = (
    data,
    schema = defaultSchema,
    id = defaultId,
    notification = true,
    throwError = false,
  ) => {
    return mutationFn(data, schema, id).then(
      (res) => onSuccess(res, data, schema, id, notification),
      (error) => {
        onError(error, notification, throwError);
      },
    );
  };

  return { mutateAsync };
}
